import { ActionCreator, AjaxDispatcher } from './ajax-dispatcher';
import { addEventListenerIfNotExists, getApiUrl, getCurrentLanguageId } from './common';
import HttpClient from './http-client';
import LoadingIndication from './loading-indication';

export default class DiscountCouponsList{
    private baseComponent: HTMLElement;
    private coupons: AppliedCoupon[];

    constructor() {
        this.initElements();
        this.registerEventListeners();
    }

    private initElements(): void {
        this.baseComponent = document.querySelector('[data-component="DiscountCouponsList"]');
        this.coupons = this.createAppliedCoupons(this.baseComponent.querySelectorAll('[data-component-part="applied-coupon-item"]'));
    }

    private registerEventListeners(): void {
        this.coupons?.forEach(coupon => {
            coupon.deleteButton &&
                addEventListenerIfNotExists(
                    coupon.deleteButton,
                    'click',
                    async () => {
                        this.showLoadingIndication();
                        await this.removeDiscountCouponFromCart(coupon.couponId);
                        this.hideLoadingIndication();
                    }
                );
        });
    }

    private createAppliedCoupons(inputElements: NodeList): AppliedCoupon[] {
        if (inputElements == null)
            return null;

        const array: HTMLInputElement[] = Array.prototype.slice.call(
            inputElements
        );

        return array.map(item => {
            return {
                couponId: parseInt(item.getAttribute('data-coupon-id')),
                deleteButton: item.querySelector('[data-action="remove"]')
            } as AppliedCoupon;
        });
    }

    private async removeDiscountCouponFromCart(couponId: number): Promise<void> {
        const client = new HttpClient();
        const url = `${getApiUrl()}/cart/remove-discount-coupon/${couponId}`;

        const response = await client.fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json;',
                'Current-Language-Id': getCurrentLanguageId()
            }
        });

        if (response.ok) {
            this.reloadComponents();
        }
    }

    private reloadComponents(): void {
        const action = new ActionCreator().reloadComponents(['Cart', 'CartHeaderIcon', 'DiscountCoupons', 'DiscountCouponsList']);
        new AjaxDispatcher().dispatchGetAction(action);
    }

    private showLoadingIndication(): void {
        LoadingIndication.show(this.baseComponent);
    }

    private hideLoadingIndication(): void {
        LoadingIndication.hide(this.baseComponent);
    }
}

interface AppliedCoupon {
    couponId: number;
    deleteButton: HTMLElement;
}
